import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ModalHeader } from 'reactstrap';
import { injectIntl } from 'react-intl';

class ShareModalHeader extends PureComponent {
  getHeaderText() {
    const {
      intl,
      mode,
      view,
      requestLoading,
      addingTemplate,
    } = this.props;

    if (view === 'files-list') {
      return intl.formatMessage({ defaultMessage: 'Files list' });
    }

    if (view === 'settings') {
      if (addingTemplate) return intl.formatMessage({ defaultMessage: 'Create new template' });
      return intl.formatMessage({ defaultMessage: 'Link settings' });
    }

    if (mode === 'request' || requestLoading) {
      return intl.formatMessage({ defaultMessage: 'Share requested files' });
    }

    return intl.formatMessage({ defaultMessage: 'Share a link' });
  }

  render() {
    const { handleClose, addingTemplate } = this.props;

    return (
      <ModalHeader
        toggle={handleClose}
        className={classnames('modal-header-center', { 'modal-header-editing-mode': addingTemplate })}
      >
        <div className="modal-header-wrapper">
          {this.getHeaderText()}
        </div>
      </ModalHeader>
    );
  }
}

ShareModalHeader.propTypes = {
  intl: PropTypes.object.isRequired,
  mode: PropTypes.string,
  view: PropTypes.string,
  addingTemplate: PropTypes.bool.isRequired,
  requestLoading: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

ShareModalHeader.defaultProps = {
  mode: null,
  view: null,
};

export default injectIntl(ShareModalHeader);
